<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-form
        class="position-relative"
      >
        <b-row>
          <b-col md="12">
            <b-card
              border-variant="success"
              bg-variant="transparent"
              class="shadow-none module-card"
            >
              <b-overlay
                :show="busy"
                rounded="lg"
                opacity="0.6"
              >

                <b-form-group
                  :label="$t('DEBTIA_DAYS')"
                  label-for="days"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Days"
                    rules="required|integer"
                  >
                    <b-form-input
                      v-model="days"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Days"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  :label="$t('DEBTIA_CONDITION')"
                  label-for="process-conditions"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <v-select
                      v-model="currentcondition"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="conditionOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="process-conditions"
                      @input="changeVariable($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  v-if="currentcondition === checkClientTypeID"
                  :label="$t('DEBTIA_CLIENT_TYPE')"
                  label-for="client-type"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_CLIENT_TYPE')"
                    rules="required"
                  >
                    <v-select
                      v-model="checkclientType"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="checkclientOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="client-type"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  v-if="CustomVariableOptions.length > 0"
                  :label="$t('DEBTIA_OPTIONS')"
                  label-for="custom-var-options"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_OPTIONS')"
                    rules="required"
                  >
                    <v-select
                      v-model="CustomVarOption"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="CustomVariableOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="file-category"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="varType !== false && varType !== 'select'"
                  :label="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
                  label-for="custom-variable-value"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="custom-variable-value"
                    rules="required"
                  >
                    <vue-timepicker
                      v-if="varType === 'time'"
                      v-model="CustomVariableValue"
                      input-width="100%"
                      input-class="form-control"
                      manual-input
                      hide-clear-button
                    />
                    <v-select
                      v-else-if="varType === 'date'"
                      v-model="dateOption"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="dateOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="date-options"
                    />
                    <b-form-textarea
                      v-else-if="varType === 'multiline string'"
                      id="textarea-rows"
                      v-model="CustomVariableValue"
                      :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
                      rows="3"
                    />
                    <b-form-radio-group
                      v-else-if="varType === 'boolean'"
                      v-model="CustomVariableValue"
                      :options="radioOptions"
                      value-field="item"
                      text-field="name"
                      disabled-field="notEnabled"
                      class="demo-inline-spacing"
                    />
                    <b-form-input
                      v-else-if="varType === 'number'"
                      v-model="CustomVariableValue"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
                    />
                    <b-form-input
                      v-else
                      v-model="CustomVariableValue"
                      :state="errors.length > 0 ? false:null"
                      :placeholder="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="varType !== false && varType === 'date'"
                  :label="$t('DEBTIA_CUTOM_VARIABLE_VALUE')"
                  label-for="custom-variable-value"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="custom-variable-date"
                    rules="required"
                  >
                    <b-input-group
                      v-if="dateOption === 1"
                    >
                      <cleave
                        v-model="daCustomVariableValue"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD-MM-YYYY"
                        @input="validateDate(0, daCustomVariableValue)"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="CustomVariableValue"
                          :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                          trim
                          button-only
                          right
                          size="sm"
                          @input="validateDate(1, CustomVariableValue)"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-input
                      v-else
                      v-model="CustomVariableValue"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Dato Felt"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <label
                      :id="'dateerror-'+CustomVarID"
                      style="color: red; display:none;"
                    >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="currentcondition === 5"
                  :label="$t('DEBTIA_FILE_CATEGORIES')"
                  label-for="file-category"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_FILE_CATEGORIES')"
                    rules="required"
                  >
                    <v-select
                      v-model="fileCategory"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="fileCategories"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="file-category"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  v-if="currentcondition === 6"
                  :label="$t('DEBTIA_CASE_GROUPS')"
                  label-for="case-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_CASE_GROUPS')"
                    rules="required"
                  >
                    <v-select
                      v-model="CaseGroup"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="CaseGroups"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="case-group"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="currentcondition === 10"
                  :label="$t('DEBTIA_TYPE')"
                  label-for="custom-var-for"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_TYPE')"
                    rules="required"
                  >
                    <v-select
                      v-model="customVarsFor"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customVarsForArgs"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="custom-var-for"
                      @input="getVarsFor()"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="currentcondition === 10"
                  :label="$t('DEBTIA_CUSTOM_VARIABLES')"
                  label-for="custom-var"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_CUSTOM_VARIABLES')"
                    rules="required"
                  >
                    <v-select
                      v-model="CustomVarID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customVars"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="custom-var"
                      :value="''"
                    >
                      <template
                        #selected-option-container="{ option }"
                      >
                        <div class="vs__selected">
                          {{ $t(option.label) }}</div>
                      </template>
                      <template
                        slot="option"
                        slot-scope="option"
                      >
                        {{ $t(option.label) }}
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="currentcondition === statementConditionID"
                  :label="SubStatementLabel"
                  label-for="sub-statement-option"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="SubStatementLabel"
                    rules="required"
                  >
                    <v-select
                      v-model="SubStatementOption"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="SubStatementOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="sub-statement-option"
                      multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="currentcondition === clientCollectionTypeID"
                  label="Type"
                  label-for="client-collection-type"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Type"
                    rules="required"
                  >
                    <v-select
                      v-model="clientCollectionType"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="clientCollectionTypeOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="client-collection-type"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="currentcondition === statementConditionID"
                  label="Value"
                  label-for="statement-value"
                >
                  <validation-provider
                    #default="{ errors }"
                    input-id="statement-value"
                    name="Value"
                    rules="required|integer"
                  >
                    <b-form-input
                      v-model="SubStatementValue"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Value"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  :label="$t('DEBTIA_OPERATOR')"
                  label-for="process-operator"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_OPERATOR')"
                    rules="required"
                  >
                    <v-select
                      v-if="currentcondition === statementConditionID"
                      v-model="currentoperator"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="statementOperatorOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="process-operator"
                    />
                    <v-select
                      v-else
                      v-model="currentoperator"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="operatorOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="process-operator"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <b-row>
                      <b-col
                        md="12"
                        class="mt-2"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="awaitCheckbox"
                            class="custom-control-primary"
                            name="checkbox-timed"
                          >
                            {{ $t('DEBTIA_AWAIT_CHECKBOX') }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </validation-provider>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    v-model="skipAwait"
                    class="custom-control-primary"
                    name="skip-await"
                  >
                    {{ $t('DEBTIA_AWAIT_SKIP_MONDAY') }}
                  </b-form-checkbox>
                </b-form-group>
                <b-button
                  class="emailSubmitBtn"
                  variant="primary"
                  type="submit"
                  @click.prevent="submitSendLetterForm"
                >
                  {{ $t('DEBTIA_SUBMIT') }}
                </b-button>
              </b-overlay>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCard,
  BFormInput,
  BOverlay,
  BFormDatepicker,
  BFormTextarea,
  BFormRadioGroup, BInputGroupAppend, BInputGroup, BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VueTimepicker from 'vue2-timepicker'
import Cleave from 'vue-cleave-component'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BCard,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BOverlay,
    BFormDatepicker,
    BFormTextarea,
    BFormRadioGroup,
    VueTimepicker,
    BInputGroupAppend,
    BFormCheckbox,
    BInputGroup,
    Cleave,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentcondition: '',
      awaitCheckbox: false,
      conditionOptions: [],
      operatorOptions: [
        { label: 'True', value: 1 },
        { label: 'False', value: 2 },
      ],
      currentoperator: '',
      fileCategories: [],
      fileCategory: '',
      CaseGroups: [],
      CaseGroup: '',
      CustomVarOption: '',
      clientCollectionTypeID: 0,
      clientCollectionType: 0,
      clientCollectionTypeOptions: [
        { label: 'Own', value: 'own' },
        { label: 'Foreign', value: 'foreign' },
      ],
      customVarsFor: 'debtor',
      customVarsForArgs: [
        {
          label: 'Debtor',
          value: 'debtor',
        },
        {
          label: 'Case',
          value: 'case',
        },
      ],
      customVarsArgs: [],
      customVars: [],
      customVar: '',
      days: null,
      NumberOfPassengers: '',
      SubStatementOption: [],
      SubStatementOptions: [],
      SubStatementLabel: '',
      SubStatementValue: '',
      busy: false,
      statementOperatorOptions: [
        { label: 'Greater Than (>)', value: 7 },
        { label: 'Greater Than, Equal to (>=)', value: 9 },
        { label: 'Less Than (<)', value: 8 },
        { label: 'Less Than, Equal to (<=)', value: 10 },
        { label: 'Equal to (=)', value: 3 },
      ],
      CustomVariableOptions: [],
      varType: false,
      CustomVariableValue: '',
      daCustomVariableValue: '',
      CustomVarID: 0,
      AirportsData: [],
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
      statementConditionID: 0,
      dateOptions: [
        { label: 'Custom Date', value: 1 },
        { label: 'Dato Felt', value: 2 },
      ],
      dateOption: 1,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      skipAwait: false,
      checkClientTypeID: 0,
      checkclientType: 'person',
      checkclientOptions: [
        { label: 'Person', value: 'person' },
        { label: 'Sole Proprietorship', value: 'sole-proprietorship' },
        { label: 'Capital Company', value: 'capital-company' },
      ],
    }
  },
  watch: {
    currentcondition: {
      handler() {
        if (this.currentcondition === this.statementConditionID) {
          this.getSubStatements()
        }
        // DEB-461 show statementOperatorOptions for date type custom vars
        const filteredOptions = this.conditionOptions.filter(e => e.value === this.currentcondition && e.type === 'date')
        if (filteredOptions.length) {
          this.operatorOptions.push(...this.statementOperatorOptions)
        } else {
          this.operatorOptions.splice(2)
        }
      },
    },
    dateOption: {
      handler() {
        this.CustomVariableValue = ''
        this.daCustomVariableValue = ''
      },
    },
  },
  created() {
    this.getConditions()
    this.getFileCategories()
    this.getCaseGroups()
    this.getCustomVars()
  },
  methods: {
    validateDate(type, value) {
      if (type === 0) {
        this.CustomVariableValue = this.$FormformattedDate(value)
      } else {
        this.daCustomVariableValue = this.$DAformattedDate(value)
      }
    },
    async getConditions() {
      this.busy = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          const conditionsData = response.data.data.variables.map(e => ({
            ...e, label: this.$t(e.label), value: e.value,
          }))
          this.conditionOptions.push(...conditionsData)
          this.AirportsData.push(...response.data.data.airports)
          const conditionID = this.conditionOptions.filter(e => e.label === 'Statements')
          this.statementConditionID = conditionID.length > 0 ? conditionID[0].value : 0
          const clientCollectionTypeID = this.conditionOptions.filter(e => e.label === 'Is client Collection Type?')
          this.clientCollectionTypeID = clientCollectionTypeID.length > 0 ? clientCollectionTypeID[0].value : 0
          const checkClientTypeID = this.conditionOptions.filter(e => e.label === 'Check client type')
          this.checkClientTypeID = checkClientTypeID.length > 0 ? checkClientTypeID[0].value : 0
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    submitSendLetterForm() {
      const statementArgs = []
      this.SubStatementOption.map(e => this.SubStatementOptions.filter(el => {
        if (e === el.value) {
          statementArgs.push({
            statement_id: el.value,
            statement_type: el.type,
          })
        }
        return statementArgs
      }))
      this.busy = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const conditionValue = this.currentoperator === 1 ? 1 : 0
          const url = '/process/module/add'
          const processID = this.$route.params.id
          const dataObj = {
            process_id: Number(processID),
            module_id: 14,
            module_order: 1,
            condition_id: this.currentcondition,
            condition_operator_id: this.currentoperator,
            skip_interest_calculation: this.awaitCheckbox,
            client_collection_type: this.currentcondition === this.clientCollectionTypeID ? this.clientCollectionType : '',
            // eslint-disable-next-line no-nested-ternary
            condition_value: this.currentoperator > 2 ? this.SubStatementValue > 0 ? this.SubStatementValue : 0 : Number(conditionValue),
            file_category_id: this.fileCategory !== '' ? this.fileCategory : 0,
            group_id: this.CaseGroup !== '' ? this.CaseGroup : 0,
            custom_option_id: this.CustomVarOption !== '' ? this.CustomVarOption : 0,
            company_custom_var_id: 0,
            days: this.days,
            no_of_passengers: this.NumberOfPassengers !== '' ? this.NumberOfPassengers : 0,
            sub_statements: statementArgs,
            custom_variable_id: this.CustomVarID,
            custom_variable_value: this.CustomVariableValue,
            date_type: this.varType === 'date' ? this.dateOption : null,
            skip_monday: this.skipAwait,
            client_type: this.checkclientType ? this.checkclientType : '',
          }
          if (this.conditionObject.moduleID > 0) {
            dataObj.depends_on = this.conditionObject.moduleID
            dataObj.condition = this.conditionObject.type
          }
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              this.currentcondition = ''
              this.awaitCheckbox = false
              this.conditionOptions = []
              this.checkclientType = 'person'
              this.currentoperator = ''
              this.fileCategory = ''
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeConditionModal', returnObj)
            }
          })
        } else {
          this.busy = false
        }
      })
    },
    async getFileCategories() {
      await axios.get('/settings/file-categories-dropdown').then(response => {
        if (response.status === 200) {
          this.fileCategories.push(...response.data.data)
        }
      }).catch(error => console.log(error))
    },
    async getCaseGroups() {
      await axios.get('/debt-case-groups-dropdown').then(response => {
        if (response.status === 200) {
          this.CaseGroups.push(...response.data.data)
        }
      }).catch(error => console.log(error))
    },
    async getCustomVars() {
      await axios.get('/get-all-custom-vars').then(response => {
        if (response.status === 200) {
          this.customVarsArgs.push(...response.data.data)
          this.customVars = this.customVarsArgs.filter(e => e.var_for === this.customVarsFor)
        }
      }).catch(error => console.log(error))
    },
    getVarsFor() {
      this.customVars = this.customVarsArgs.filter(e => e.var_for === this.customVarsFor)
      this.CustomVarID = 0
    },
    async getSubStatements() {
      this.busy = true
      const getStatementlabel = this.conditionOptions.filter(e => e.value === this.currentcondition)
      this.SubStatementLabel = getStatementlabel.length > 0 ? getStatementlabel[0].label : ''
      this.SubStatementOption = []
      this.SubStatementOptions = []
      await axios.get('/get-sub-statements').then(response => {
        if (response.status === 200) {
          this.SubStatementOption = ''
          this.SubStatementOptions.push(...response.data.data)
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    changeVariable(event) {
      this.varType = false
      this.CustomVarOption = ''
      this.CustomVariableOptions = []
      this.CustomVariableValue = ''
      this.conditionOptions.filter(e => {
        if (event === e.value) {
          if (e.type === 'select') {
            if (e.options.length > 0) {
              this.CustomVariableOptions.push(...e.options)
            } else {
              this.CustomVariableOptions.push(...this.AirportsData)
            }
          }
          this.varType = e.type
          this.CustomVarID = e.customVarID
        }
        return true
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .emailSubmitBtn {
    width: 100%;
  }
</style>
